import { apiClient } from "./api";

// Activity types
export interface Activity {
  id: string;
  type: string;
  description: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
  user?: {
    id: string;
    name: string;
    email: string;
    avatarUrl?: string;
  };
  campaign?: {
    id: string;
    title: string;
    description: string;
  };
}

export interface ActivityFilters {
  limit?: number;
  offset?: number;
  type?: string;
  userId?: string;
  campaignId?: string;
}

export interface ActivityStats {
  totalActivities: number;
  todayActivities: number;
  userActivities: number;
  campaignActivities: number;
}

// Activity API service
export const activityApi = {
  // Get user activities
  async getUserActivities(filters?: ActivityFilters): Promise<Activity[]> {
    const params = new URLSearchParams();
    if (filters?.limit) params.append("limit", filters.limit.toString());
    if (filters?.offset) params.append("offset", filters.offset.toString());
    if (filters?.type) params.append("type", filters.type);
    if (filters?.campaignId) params.append("campaignId", filters.campaignId);

    return apiClient.get<Activity[]>(`/activities/user?${params.toString()}`);
  },

  // Get admin activities
  async getAdminActivities(filters?: ActivityFilters): Promise<Activity[]> {
    const params = new URLSearchParams();
    if (filters?.limit) params.append("limit", filters.limit.toString());
    if (filters?.offset) params.append("offset", filters.offset.toString());
    if (filters?.type) params.append("type", filters.type);
    if (filters?.userId) params.append("userId", filters.userId);
    if (filters?.campaignId) params.append("campaignId", filters.campaignId);

    return apiClient.get<Activity[]>(`/activities/admin?${params.toString()}`);
  },

  // Get recent activities
  async getRecentActivities(limit?: number): Promise<Activity[]> {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit.toString());

    return apiClient.get<Activity[]>(`/activities/recent?${params.toString()}`);
  },

  // Get activity stats (admin only)
  async getActivityStats(): Promise<ActivityStats> {
    return apiClient.get<ActivityStats>("/activities/stats");
  },
};
